import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type UserWithId = {
  idUser: number;
};

// Базовый тип для общих полей пользователя
type UserCommonFields = {
  name: string;
  admin: boolean;
  block: boolean;
  theme?: string | null;
};

// Типы для WebSocket сообщений компонента users
type UserListMessage = WebSocketMessageWithFields<'user-list', {
  users: unknown[];
}>;
type UserCreateMessage = WebSocketMessageWithFields<'user-create', UserWithId & {
  email: string;
  name: string;
  idLanguage?: number | null;
  admin?: boolean;
  block?: boolean;
  confirmEmail?: boolean;
  theme?: string | null;
}>;
type UserUpdateMessage = WebSocketMessageWithFields<'user-update' | 'user-update-success', UserWithId & UserCommonFields>;
type UserDeleteMessage = WebSocketMessageWithFields<'user-delete', UserWithId>;
type UserEmailConfirmMessage = WebSocketMessageWithFields<'user-email-confirm', UserWithId>;
type UserNameMessage = WebSocketMessageWithFields<'user-name', UserWithId & {
  name: string;
}>;
type UserThemeMessage = WebSocketMessageWithFields<'user-theme', UserWithId & {
  theme: string;
}>;
type UserChangeEmailMessage = WebSocketMessageWithFields<'user-change-email', UserWithId & {
  email: string;
}>;

// Объединенный тип для всех сообщений
type UsersWebSocketMessage = 
  | UserListMessage 
  | UserCreateMessage 
  | UserUpdateMessage 
  | UserDeleteMessage 
  | UserEmailConfirmMessage 
  | UserNameMessage 
  | UserThemeMessage 
  | UserChangeEmailMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataUsers',
},
  __name: 'users',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID пользователя
const handleWebSocketMessage = (data: UsersWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'user-list':
      store.dispatch('users/wsSetUsers', {
        users: data.users,
      });
      break;

    case 'user-create':
      store.dispatch('users/wsUserCreate', {
        idUser: data.idUser,
        email: data.email,
        name: data.name,
        idLanguage: data.idLanguage ?? null,
        admin: data.admin ?? false,
        block: data.block ?? false,
        confirmEmail: data.confirmEmail ?? false,
        theme: data.theme ?? null,
      });
      break;

    case 'user-update':
    case 'user-update-success':
      store.dispatch('users/wsUserUpdate', {
        idUser: data.idUser,
        name: data.name,
        admin: data.admin,
        block: data.block,
        theme: data.theme ?? null,
      });
      break;

    case 'user-delete':
      store.dispatch('users/wsUserDelete', {
        idUser: data.idUser,
      });
      break;

    case 'user-email-confirm':
      store.dispatch('users/wsUserEmailConfirm', {
        idUser: data.idUser,
      });
      break;

    case 'user-name':
      store.dispatch('users/wsUserName', {
        idUser: data.idUser,
        name: data.name,
      });
      break;

    case 'user-theme':
      store.dispatch('users/wsUserTheme', {
        idUser: data.idUser,
        theme: data.theme,
      });
      break;

    case 'user-change-email':
      store.dispatch('users/wsUserChangeEmail', {
        idUser: data.idUser,
        email: data.email,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})